var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from '../elements/icon';
import { classNames } from '@shapeable/utils';
import { useLink } from '../hooks/use-link';
import { useComponentPropsFor } from '../context/component-props-context';
import { ThemeModeProvider } from '../context/theme-mode-context';
var cls = classNames('site-header-utility-button');
export var SiteHeaderUtilityButtonDefaultProps = {
  variant: 'default',
  isInverted: true,
  menuThemeMode: 'dark',
  isMenuInverted: true,
  iconSize: 16,
  colors: {
    text: 'strong',
    background: 'justVisible',
    hover: {
      background: 'verySubtle'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow: visible;\n  "], ["\n    position: relative;\n    overflow: visible;\n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    height: 32px;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    gap: ", ";\n\n    ", "\n    \n    white-space: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n    flex-shrink: 0;\n    border-radius: 16px;\n    cursor: pointer;\n\n    ", "\n    \n    ", ";\n    \n    ", "\n\n\n  "], ["\n    ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    height: 32px;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    gap: ", ";\n\n    ", "\n    \n    white-space: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n    flex-shrink: 0;\n    border-radius: 16px;\n    cursor: pointer;\n\n    ", "\n    \n    ", ";\n    \n    ", "\n\n\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.FONT('sans'), theme.FONT_SIZE(12), theme.UNIT(1.5), function (_a) {
    var hasIcon = _a.hasIcon;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding: 0 ", " 1px ", ";\n    "], ["\n      padding: 0 ", " 1px ", ";\n    "])), theme.UNIT(3), theme.UNIT(3));
  }, function (_a) {
    var variant = _a.variant;
    return variant === 'pinned' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: 0 ", " 2px ", ";\n      border-radius: 0 0px 8px 8px;\n    "], ["\n      padding: 0 ", " 2px ", ";\n      border-radius: 0 0px 8px 8px;\n    "])), theme.UNIT(3), theme.UNIT(2, 2));
  }, theme.APPLY_COLORS, function (_a) {
    var variant = _a.variant;
    return variant === 'icon' && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-left: ", ";\n      background-color: transparent !important;\n      padding: 0;\n    "], ["\n      margin-left: ", ";\n      background-color: transparent !important;\n      padding: 0;\n    "])), theme.UNIT(2));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var variant = _a.variant;
    return variant !== 'icon' && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
});
var MenuStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    opacity: 0.98;\n    position: absolute;\n    flex-direction: column;\n    top: -", ";\n    right: -", ";\n    z-index: 120;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    border-radius: 0 0 8px 8px;\n    min-width: 80px;\n    border: 1px solid ", ";\n    background: ", ";\n  "], ["\n    display: flex;\n    opacity: 0.98;\n    position: absolute;\n    flex-direction: column;\n    top: -", ";\n    right: -", ";\n    z-index: 120;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    border-radius: 0 0 8px 8px;\n    min-width: 80px;\n    border: 1px solid ", ";\n    background: ", ";\n  "])), theme.UNIT(4, 1), theme.UNIT(4, 1), theme.UNIT(4), theme.UNIT(2), theme.COLOR('brightWarm'), theme.COLOR('bright'))
});
var MenuButtonStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: 0 ", ";\n    align-self: flex-end;\n    margin-bottom: 8px;\n    button {\n      transition: none;\n    }\n  "], ["\n    padding: 0 ", ";\n    align-self: flex-end;\n    margin-bottom: 8px;\n    button {\n      transition: none;\n    }\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  NAME: "SiteHeaderUtilityButton",
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Button: styled.button.attrs(cls.attr('button'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Icon: styled(Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Menu: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), MenuStyles),
  MenuButton: styled.div.attrs(cls.attr('menu-button'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles)
};
export var SiteHeaderUtilityButton = function (props) {
  var _a = useComponentPropsFor(My.NAME, SiteHeaderUtilityButtonDefaultProps, props),
    className = _a.className,
    variant = _a.variant,
    children = _a.children,
    iconSize = _a.iconSize,
    menuThemeMode = _a.menuThemeMode,
    menu = _a.menu,
    isMenuVisible = _a.isMenuVisible,
    colors = _a.colors;
  var Icon = props.iconComponent;
  var navigate = useLink().navigate;
  var onClick = props.onClick || props.href && function () {
    navigate(props.href);
  };
  var button = React.createElement(My.Button, {
    hasIcon: !!Icon,
    colors: colors,
    variant: variant,
    onClick: onClick,
    type: "button"
  }, Icon && React.createElement(My.Icon, {
    variant: variant,
    color: colors.text,
    size: variant === 'icon' ? 24 : iconSize
  }, React.createElement(Icon, null)), variant !== 'icon' && children);
  var menuButton = React.createElement(My.Button, {
    hasIcon: !!Icon,
    colors: colors,
    variant: variant,
    onClick: onClick,
    type: "button"
  }, Icon && React.createElement(My.Icon, {
    variant: variant,
    color: colors.text,
    size: variant === 'icon' ? 24 : iconSize
  }, React.createElement(Icon, null)), variant !== 'icon' && children);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, button, isMenuVisible && menu && React.createElement(ThemeModeProvider, {
    value: menuThemeMode
  }, React.createElement(My.Menu, null, React.createElement(My.MenuButton, null, menuButton), menu)));
};
SiteHeaderUtilityButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;